import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'toIconUrl'})
export class ResourceIconPipe implements PipeTransform {

  transform(image: string) {
    let baseUrl = '/assets/images/';
    return baseUrl + image + ".png";
  }

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/common/utils/icon/resource.icon.pipe.ts